import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'

import TopBar from '../../components/TopBar'
import { getCustomer, updateCustomer } from '../../api/customersApi'
import DeleteConfirmationPopup from '../../components/DeleteConfirmationPopup'
import editIcon from '../../assets/images/pen-img.svg'
import deleteIcon from '../../assets/images/delete.svg'
import moreIcon from '../../assets/images/more.svg'
import featured from "../../assets/images/featured.svg";
import styles from './page.module.css'
import UploadMediaPopup from '../../components/UploadMediaPopup'

const EditCustomer = () => {
    const { customerId } = useParams()
    const dropdownRef = useRef(null);

    const [errors, setErrors] = useState({})
    const [formData, setFormData] = useState({
        fullName: "",
        email: "",
        password: "",
        location: "",
        mobileNumber: "",
        image: ""
    });
    const [isLoading, setIsLoading] = useState(false)
    const [showAddressForm, setShowAddressForm] = useState(false)
    const [addresses, setAddresses] = useState([])
    const [currentAddress, setCurrentAddress] = useState({
        firstName: "",
        lastName: "",
        companyName: "",
        country: "",
        address: "",
        city: "",
        state: "",
        zipCode: "",
        phone: "",
        email: "",
        location: "Home"
    });
    const [addressErrors, setAddressErrors] = useState({});
    const [editingIndex, setEditingIndex] = useState(null);
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
    const [deleteIndex, setDeleteIndex] = useState(null);
    const [showDropdownIndex, setShowDropdownIndex] = useState(null);

    const [showUploadMediaPopup, setShowUploadMediaPopup] = useState(false);
    const [uploadMediaPopupFor, setUploadMediaPopupFor] = useState('');
    const [uploadMediaPopupTab, setUploadMediaPopupTab] = useState('upload');
    const [selectedFeatureImage, setSelectedFeatureImage] = useState('');

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdownIndex(null);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (selectedFeatureImage) {
            setFormData({
                ...formData,
                image: selectedFeatureImage[0]
            });
        }
    }, [selectedFeatureImage]);

    useEffect(() => {
        if (!customerId) return;

        const fetchCustomer = async () => {
            try {
                const response = await getCustomer(customerId);

                if (response?.success) {
                    setFormData({
                        ...response.data,
                        password: ''
                    });
                    setAddresses(response?.data?.address || [])
                }
            } catch (error) {
                console.log("Failed to fetch customer:", error);
            }
        };

        fetchCustomer();
    }, [customerId]);

    const validateForm = () => {
        let newErrors = {};

        if (!formData?.fullName.trim()) {
            newErrors.fullName = "Name is required";
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!formData?.email?.trim()) {
            newErrors.email = "Email is required";
        } else if (!emailRegex.test(formData?.email)) {
            newErrors.email = "Enter a valid email address";
        }

        const phoneRegex = /^[0-9]{10}$/;
        if (!formData?.mobileNumber?.trim()) {
            newErrors.mobileNumber = "Mobile number is required";
        } else if (!phoneRegex.test(formData?.mobileNumber)) {
            newErrors.mobileNumber = "Enter valid 10-digit phone number";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const validateAddressForm = () => {
        let newErrors = {};

        if (!currentAddress.firstName.trim()) {
            newErrors.firstName = "First name is required";
        }
        if (!currentAddress.lastName.trim()) {
            newErrors.lastName = "Last name is required";
        }

        const phoneRegex = /^[0-9]{10}$/;
        if (!currentAddress.phone.trim()) {
            newErrors.phone = "Mobile number is required";
        } else if (!phoneRegex.test(currentAddress.phone)) {
            newErrors.phone = "Enter valid 10-digit phone number";
        }

        const pincodeRegex = /^[0-9]{6}$/;
        if (!currentAddress.zipCode.trim()) {
            newErrors.zipCode = "Pincode is required";
        } else if (!pincodeRegex.test(currentAddress.zipCode)) {
            newErrors.zipCode = "Enter valid 6-digit zipCode";
        }

        if (!currentAddress.address.trim()) {
            newErrors.address = "Address is required";
        }

        if (!currentAddress.city.trim()) {
            newErrors.city = "City is required";
        }

        if (!currentAddress.state.trim()) {
            newErrors.state = "State is required";
        }

        if (!currentAddress.country.trim()) {
            newErrors.country = "Country is required";
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!currentAddress?.email?.trim()) {
            newErrors.email = "Email is required";
        } else if (!emailRegex.test(currentAddress?.email)) {
            newErrors.email = "Enter a valid email address";
        }

        setAddressErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSave = async () => {
        if (!validateForm()) return;

        try {
            setIsLoading(true)
            const response = await updateCustomer(customerId, {
                fullName: formData?.fullName,
                email: formData?.email,
                password: formData?.password,
                mobileNumber: formData?.mobileNumber,
                location: formData?.location,
                address: addresses,
                image: formData?.image?.id || null,
            });
            if (response?.success) {
                setIsLoading(false)
            }
        } catch (error) {
            setIsLoading(false)
            console.log({ error })
        }
    };

    const handleImageUpload = (e) => {
        e.stopPropagation();
        setShowUploadMediaPopup(true); setUploadMediaPopupFor('feature-image'); setUploadMediaPopupTab('media');
    };

    return (
        <div>
            <TopBar />
            <div className={styles.generalContent}>
                <div className={styles.generalRow}>
                    <div className={styles.formControltems}>
                        <div className={styles.formControlInputs}>
                            <div className={styles.formControlFields}>
                                <label className={styles.fieldsLabel}>Name</label>
                                <input
                                    type="text"
                                    value={formData?.fullName}
                                    className={styles.inputFields}
                                    onChange={(e) => {
                                        setFormData({ ...formData, fullName: e.target.value });
                                        setErrors(prev => ({ ...prev, fullName: "" }));
                                    }}

                                    autoComplete="off"
                                    placeholder='Enter name'
                                />
                                {errors.fullName && (
                                    <div className='error-message'>{errors.fullName}</div>
                                )}
                            </div>

                            <div className={styles.formControlFields}>
                                <label className={styles.fieldsLabel}>Email</label>

                                <div className={`${styles.inputFieldsIcon} ${styles.userEmail}`}>
                                    {/* <img src={iconEmail} alt="email-icon" /> */}
                                    <input
                                        type="text"
                                        className={styles.inputFields}
                                        value={formData?.email}
                                        onChange={(e) => {
                                            setFormData({ ...formData, email: e.target.value });
                                            setErrors(prev => ({ ...prev, email: "" }));
                                        }}
                                        autoComplete="off"
                                        placeholder='Enter email'
                                    />
                                </div>

                                {errors.email && (
                                    <div className='error-message'>{errors.email}</div>
                                )}
                            </div>

                        </div>
                    </div>
                </div>

                <div className={styles.generalRow}>
                    <div className={styles.formControltems}>
                        <div className={`${styles.formControlInputs} ${styles.formControlFull}`}>
                            <div className={styles.formControlFields}>
                                <label className={styles.fieldsLabel}>Password</label>
                                <input
                                    type="password"
                                    value={formData?.password}
                                    className={styles.inputFields}
                                    onChange={(e) => {
                                        setFormData({ ...formData, password: e.target.value });
                                    }}
                                    autoComplete="new-password"
                                    placeholder='Enter password'
                                />
                            </div>
                            <div className={styles.formControlFields}>
                                <label className={styles.fieldsLabel}>Mobile number</label>
                                <div className={styles.inputFieldsIcon}>
                                    {/* <img src={iconPhone} alt="phone" /> */}
                                    <input
                                        className={styles.inputFields}
                                        type="number"
                                        value={formData?.mobileNumber}
                                        autoComplete="off"
                                        onChange={(e) => {
                                            setFormData({ ...formData, mobileNumber: e.target.value });
                                            setErrors(prev => ({ ...prev, mobileNumber: "" }));
                                        }}
                                        placeholder='Enter mobile number'
                                    />
                                </div>

                                {errors.mobileNumber && (
                                    <div className='error-message'>{errors.mobileNumber}</div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.generalRow}>
                    <div className={styles.formControltems}>
                        <div className={styles.formControlInputs}>
                            <div className={styles.formControlFields}>
                                <label className={styles.fieldsLabel}>Location</label>
                                <div className={styles.inputFieldsIcon}>
                                    {/* <img src={iconPhone} alt="phone" /> */}
                                    <input
                                        className={styles.inputFields}
                                        type="text"
                                        value={formData?.location}
                                        autoComplete="off"
                                        onChange={(e) => {
                                            setFormData({ ...formData, location: e.target.value });
                                            setErrors(prev => ({ ...prev, location: "" }));
                                        }}
                                        placeholder='Enter location'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.generalRow}>
                    <div className={styles.formControltems}>
                        <div className={styles.formControlInputs}>
                            <div className={styles.formControlFields}>

                                <label className={styles.fieldsLabel}>Profile Image</label>
                                <div className={`imageUploadBox`} onClick={(e) => { handleImageUpload(e) }}>
                                    <div id="newpageImageUpload" >
                                        <div className='image-upload-content'>

                                            {formData?.image ? (
                                                <div className="image-preview">
                                                    <img
                                                        src={formData?.image?.url || ''}
                                                        alt={formData?.image?.name || 'Featured Image'}
                                                        className="preview-img"
                                                    />
                                                </div>
                                            ) : <img src={featured} alt="FeaturedImage" />}
                                            <p >
                                                <span>Upload</span> <span>Media </span>
                                                <br />
                                                JPG, PNG (max. 128MB)
                                            </p>
                                        </div>
                                    </div>
                                    <input type="file" id="feature-img" accept="image/*" hidden />
                                </div>


                                {errors?.image && (
                                    <p className="error-message">{errors?.image}</p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                {/* Address List */}
                {addresses?.length > 0 && (
                    <div className={styles.addressList}>
                        {addresses?.map((addr, index) => (
                            <div key={index} className={styles.addressCard}>

                                {/* Address Type Badge */}
                                <div className={styles.addressType}>
                                    {addr.location}
                                </div>

                                {/* Main Content */}
                                <div className={styles.addressContent}>
                                    <div className={styles.addressHeader}>
                                        <span className={styles.addressName}>
                                            {addr?.firstName} {addr?.lastName}
                                        </span>
                                        <span className={styles.addressPhone}>
                                            {addr?.phone}
                                        </span>
                                    </div>

                                    <div className={styles.addressText}>
                                        {addr?.address}, {addr?.city}, {addr?.state} - {addr?.zipCode}
                                    </div>
                                </div>

                                {/* Actions */}
                                <div className={styles.addressActions}>
                                    <button
                                        className={styles.moreButton}
                                        onClick={() => setShowDropdownIndex(showDropdownIndex === index ? null : index)}
                                    >
                                        <img src={moreIcon} alt="more" />
                                    </button>
                                    {showDropdownIndex === index && (
                                        <div className={styles.dropdown} ref={dropdownRef}>
                                            <button
                                                className={styles.dropdownItem}
                                                onClick={() => {
                                                    setCurrentAddress(addr);
                                                    setEditingIndex(index);
                                                    setShowAddressForm(true);
                                                    setShowDropdownIndex(null);
                                                }}
                                            >
                                                <img src={editIcon} alt="edit" /> Edit
                                            </button>
                                            <button
                                                className={styles.dropdownItem}
                                                onClick={() => {
                                                    setDeleteIndex(index);
                                                    setShowDeleteConfirmation(true);
                                                    setShowDropdownIndex(null);
                                                }}
                                            >
                                                <img src={deleteIcon} alt="delete" /> Delete
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                <div className={styles.buttonsGroup}>
                    {editingIndex === null && <button className={styles.addNewAddress} onClick={() => {
                        setEditingIndex(null);
                        setCurrentAddress({
                            firstName: "",
                            lastName: "",
                            companyName: "",
                            country: "",
                            address: "",
                            city: "",
                            state: "",
                            zipCode: "",
                            phone: "",
                            email: "",
                            location: "Home"
                        });
                        setShowAddressForm(true);
                    }}>Add new address</button>}
                </div>

                {showAddressForm && (
                    <div className={`${styles.generalContent} ${styles.addAddressContent}`}>
                        <div className={styles.generalRow}>
                            <div className={styles.formControltems}>
                                <div className={`${styles.formControlInputs} ${styles.formControlFull}`}>
                                    <div className={styles.formControlFields}>
                                        <label className={styles.fieldsLabel}>First name</label>
                                        <input
                                            type="text"
                                            value={currentAddress.firstName}
                                            className={styles.inputFields}
                                            onChange={(e) => {
                                                setCurrentAddress({ ...currentAddress, firstName: e.target.value });
                                                setAddressErrors(prev => ({ ...prev, firstName: "" }));
                                            }}
                                            placeholder='Enter first name'
                                        />
                                        {addressErrors.firstName && (
                                            <div className='error-message'>{addressErrors.firstName}</div>
                                        )}
                                    </div>
                                    <div className={styles.formControlFields}>
                                        <label className={styles.fieldsLabel}>Last name</label>
                                        <input
                                            type="text"
                                            value={currentAddress.lastName}
                                            className={styles.inputFields}
                                            onChange={(e) => {
                                                setCurrentAddress({ ...currentAddress, lastName: e.target.value });
                                                setAddressErrors(prev => ({ ...prev, lastName: "" }));
                                            }}
                                            placeholder='Enter last name'
                                        />
                                        {addressErrors.lastName && (
                                            <div className='error-message'>{addressErrors.lastName}</div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={styles.generalRow}>
                            <div className={styles.formControltems}>
                                <div className={styles.formControlInputs}>
                                    <div className={styles.formControlFields}>
                                        <label className={styles.fieldsLabel}>Email</label>
                                        <input
                                            type="email"
                                            value={currentAddress.email}
                                            className={styles.inputFields}
                                            onChange={(e) => {
                                                setCurrentAddress({ ...currentAddress, email: e.target.value });
                                                setAddressErrors(prev => ({ ...prev, email: "" }));
                                            }}
                                            placeholder='Enter email'
                                        />
                                        {addressErrors.email && (
                                            <div className='error-message'>{addressErrors.email}</div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={styles.generalRow}>
                            <div className={styles.formControltems}>
                                <div className={`${styles.formControlInputs} ${styles.formControlFull}`}>
                                    <div className={styles.formControlFields}>
                                        <label className={styles.fieldsLabel}>Mobile Number</label>
                                        <input
                                            type="number"
                                            value={currentAddress.phone}
                                            className={styles.inputFields}
                                            onChange={(e) => {
                                                setCurrentAddress({ ...currentAddress, phone: e.target.value });
                                                setAddressErrors(prev => ({ ...prev, phone: "" }));
                                            }}
                                            placeholder='Enter phone number'
                                        />
                                        {addressErrors.phone && (
                                            <div className='error-message'>{addressErrors.phone}</div>
                                        )}
                                    </div>
                                    <div className={styles.formControlFields}>
                                        <label className={styles.fieldsLabel}>Company name</label>
                                        <input
                                            type="text"
                                            value={currentAddress.companyName}
                                            className={styles.inputFields}
                                            onChange={(e) => {
                                                setCurrentAddress({ ...currentAddress, companyName: e.target.value });
                                                setAddressErrors(prev => ({ ...prev, companyName: "" }));
                                            }}
                                            placeholder='Enter company name'
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={styles.generalRow}>
                            <div className={styles.formControltems}>
                                <div className={`${styles.formControlInputs} ${styles.formControlFull}`}>
                                    <div className={styles.formControlFields}>
                                        <label className={styles.fieldsLabel}>Address</label>
                                        <input
                                            type='text'
                                            value={currentAddress.address}
                                            className={styles.inputFields}
                                            onChange={(e) => {
                                                setCurrentAddress({ ...currentAddress, address: e.target.value });
                                                setAddressErrors(prev => ({ ...prev, address: "" }));
                                            }}
                                            placeholder='Enter address'
                                        />
                                        {addressErrors.address && (
                                            <div className='error-message'>{addressErrors.address}</div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={styles.generalRow}>
                            <div className={styles.formControltems}>
                                <div className={styles.formControlInputs}>
                                    <div className={styles.formControlFields}>
                                        <label className={styles.fieldsLabel}>City</label>
                                        <input
                                            type="text"
                                            value={currentAddress.city}
                                            className={styles.inputFields}
                                            onChange={(e) => {
                                                setCurrentAddress({ ...currentAddress, city: e.target.value });
                                                setAddressErrors(prev => ({ ...prev, city: "" }));
                                            }}
                                            placeholder='Enter city'
                                        />
                                        {addressErrors.city && (
                                            <div className='error-message'>{addressErrors.city}</div>
                                        )}
                                    </div>
                                    <div className={styles.formControlFields}>
                                        <label className={styles.fieldsLabel}>State</label>
                                        <input
                                            type="text"
                                            value={currentAddress.state}
                                            className={styles.inputFields}
                                            onChange={(e) => {
                                                setCurrentAddress({ ...currentAddress, state: e.target.value });
                                                setAddressErrors(prev => ({ ...prev, state: "" }));
                                            }}
                                            placeholder='Enter state'
                                        />
                                        {addressErrors.state && (
                                            <div className='error-message'>{addressErrors.state}</div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={styles.generalRow}>
                            <div className={styles.formControltems}>
                                <div className={styles.formControlInputs}>
                                    <div className={styles.formControlFields}>
                                        <label className={styles.fieldsLabel}>Country</label>
                                        <input
                                            type="text"
                                            value={currentAddress.country}
                                            className={styles.inputFields}
                                            onChange={(e) => setCurrentAddress({ ...currentAddress, country: e.target.value })}
                                            placeholder='Enter country'
                                        />
                                    </div>
                                    <div className={styles.formControlFields}>
                                        <label className={styles.fieldsLabel}>Pincode</label>
                                        <input
                                            type="text"
                                            value={currentAddress.zipCode}
                                            className={styles.inputFields}
                                            onChange={(e) => {
                                                setCurrentAddress({ ...currentAddress, zipCode: e.target.value });
                                                setAddressErrors(prev => ({ ...prev, zipCode: "" }));
                                            }}
                                            placeholder='Enter pincode'
                                        />
                                        {addressErrors.zipCode && (
                                            <div className='error-message'>{addressErrors.zipCode}</div>
                                        )}
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className={styles.generalRow}>
                            <div className={styles.formControltems}>
                                <div className={styles.formControlInputs}>
                                    <div className={styles.formControlFields}>

                                        <label className={styles.fieldsLabel}>Address Type</label>
                                        <div className={styles.radioGroup}>
                                            <div className={styles.radioGroupItem}>
                                                <input
                                                    type="radio"
                                                    className="custom-radio"
                                                    name="addressType"
                                                    value="Home"
                                                    checked={currentAddress.location === 'Home'}
                                                    onChange={(e) => setCurrentAddress({ ...currentAddress, location: e.target.value })}
                                                />
                                                <label htmlFor='Home' onClick={(e) => setCurrentAddress({ ...currentAddress, location: 'Home' })}>Home</label>
                                            </div>
                                            <div className={styles.radioGroupItem}>
                                                <input
                                                    type="radio"
                                                    name="addressType"
                                                    className="custom-radio"
                                                    value="Office"
                                                    checked={currentAddress.location === 'Office'}
                                                    onChange={(e) => setCurrentAddress({ ...currentAddress, location: e.target.value })}
                                                />
                                                <label htmlFor='Office' onClick={(e) => setCurrentAddress({ ...currentAddress, location: 'Office' })}>Office</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={styles.buttonsGroup}>
                            <button className={styles.saveButton} onClick={() => {
                                if (!validateAddressForm()) return;
                                if (editingIndex !== null) {
                                    const newAddresses = [...addresses];
                                    newAddresses[editingIndex] = currentAddress;
                                    setAddresses(newAddresses);
                                } else {
                                    setAddresses([...addresses, currentAddress]);
                                }
                                setCurrentAddress({
                                    firstName: "",
                                    lastName: "",
                                    companyName: "",
                                    country: "",
                                    address: "",
                                    city: "",
                                    state: "",
                                    zipCode: "",
                                    phone: "",
                                    email: "",
                                    location: "Home"
                                });
                                setAddressErrors({});
                                setShowAddressForm(false);
                                setEditingIndex(null);
                            }}>Save</button>
                            <button className={styles.saveButton} onClick={() => {
                                setCurrentAddress({
                                    firstName: "",
                                    lastName: "",
                                    companyName: "",
                                    country: "",
                                    address: "",
                                    city: "",
                                    state: "",
                                    zipCode: "",
                                    phone: "",
                                    email: "",
                                    location: "Home"
                                });
                                setAddressErrors({});
                                setShowAddressForm(false);
                                setEditingIndex(null);
                            }}>Cancel</button>
                        </div>
                    </div>
                )}

                {showDeleteConfirmation && (
                    <DeleteConfirmationPopup
                        showDeletePopup={showDeleteConfirmation}
                        setShowDeletePopup={setShowDeleteConfirmation}
                        title="Address"
                        description="Are you sure you want to delete this address?"
                        confirmDelete={() => {
                            setAddresses(addresses.filter((_, i) => i !== deleteIndex));
                            setShowDeleteConfirmation(false);
                            if (deleteIndex === editingIndex) {
                                setShowAddressForm(false)
                                setEditingIndex(null);
                            }
                        }}
                    />
                )}
                {showUploadMediaPopup &&
                    <UploadMediaPopup showUploadMediaPopup={showUploadMediaPopup} setShowUploadMediaPopup={setShowUploadMediaPopup} setSelectedProfileImage={setSelectedFeatureImage} uploadMediaPopupFor={uploadMediaPopupFor} uploadMediaPopupTab={uploadMediaPopupTab} />
                }
            </div>
            <div className={`${styles.buttonsGroup} ${styles.buttonSaveLast}`}>

                <button className={`${styles.saveButton} ${styles.saveChangeButton}`} onClick={() => { handleSave() }}>
                    {
                        isLoading ? <div className={`ringLoader loaderContinue`}></div> : 'Save Changes'
                    }
                </button>
            </div>
        </div>
    )
}

export default EditCustomer
